// Centralized sessionStorage/localStorage key constants for WABA signup flow
// Namespaced to reduce collision risk.

export const STORAGE_KEYS = {
  phoneNumberId: "waba:phone_number_id",
  wabaId: "waba:waba_id",
  businessId: "waba:business_id",
  callbackUrl: "waba:callback_url",
  state: "waba:state",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export function setSessionItem(key: StorageKey, value: string) {
  try {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(key, value);
    }
  } catch {
    // noop
  }
}

export function getSessionItem(key: StorageKey): string | null {
  try {
    if (typeof window !== "undefined") {
      return window.sessionStorage.getItem(key);
    }
  } catch {
    // noop
  }
  return null;
}
